module.exports = __webpack_public_path__ + "static/media/screens.6b79e702.png";